const Card = {
  baseStyle: {
    container: {
      bg: 'surface.default',
      borderRadius: 'lg',
      border: '1px solid',
      borderColor: 'border.default',
      overflow: 'hidden',
    },
  },
  variants: {
    elevated: {
      container: {
        boxShadow: 'sm',
        transitionProperty: 'box-shadow, transform',
        transitionDuration: '200ms',
        _hover: { boxShadow: 'md', transform: 'translateY(-2px)' },
      },
    },
    flat: { container: { boxShadow: 'none' } },
  },
  defaultProps: { variant: 'elevated' },
};

export default Card;
